import React, { useState } from "react";
import { firestore } from "../firebase";
import myfuctions from "../services/myfunctions";
import { toast } from "react-toastify";

//  ---------------------------------------------------------------> FORMIK
import * as Yup from "yup";
import { useFormik } from "formik";
// <---------------------------------------------------------------- FORMIK
// ---------------------------------------------------------------> MATERIAL UI
import { TextField, Button } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";
// <---------------------------------------------------------------- MATERIAL UI

const RedditTextField = styled((props) => (
  <TextField InputProps={{ disableUnderline: true }} {...props} />
))(({ theme }) => ({
  "& label ": {
    color: "#000",
  },
  "& label.Mui-focused": {
    color: "#000",
    fontWeight: "bold",
  },
  "& .Mui-error": {
    color: "#000",
  },
  "& .MuiFilledInput-root": {
    border: "1px solid #grey",
    overflow: "hidden",
    borderRadius: 10,
    backgroundColor: "#fff",
    transition: theme.transitions.create([
      "border-color",
      "background-color",
      "box-shadow",
    ]),
    "&:hover": {
      backgroundColor: "#fff",
    },
    "&.Mui-focused": {
      backgroundColor: "#fff",
      boxShadow: `${alpha("#000", 0.25)} 0 0 0 4px`,
      borderColor: theme.palette.primary.main,
    },
  },
}));

const SendButtonSmall = styled(Button)(({ theme }) => ({
  color: theme.palette.getContrastText("#000"),
  backgroundColor: "#1a5080",
  "&:hover": {
    backgroundColor: "#85a537",
  },
  width: "140px",
  height: "50px",
  fontWeight: "bold",
  fontSize: "14px",
  borderRadius: "20px",
  lineHeight: 1.2,
  boxShadow:
    "0 13px 27px -5px rgba(50, 50, 93, 0.25),    0 8px 16px -8px rgba(0, 0, 0, 0.3)",
}));

function Login() {
  const [disabled, setDisabled] = useState(false);
  const [error, setError] = useState(null);

  const formik = useFormik({
    initialValues: {
      fullName: "",
      dni: "",
      mobilePhone: "",
      nic: "",
    },
    validationSchema: Yup.object({
      fullName: Yup.string().required("El nombre completo es obligatorio"),
      dni: Yup.number().required("Número de documento obligatorio"),
      mobilePhone: Yup.string()
        .required("El celular es obligatorio")
        .matches(
          /^[0-9]{10}$/,
          "Lo Sentimos, Por favor revisar tu número de teléfono."
        ),
      nic: Yup.string()
        .required()
        .matches(
          /^[0-9]{7}$/,
          "Lo Sentimos, El número de NIC debe contener 7 Digitos."
        ),
    }),
    onSubmit: async (formData) => {
      try {
        setDisabled(true);
        firestore
          .collection("registeredUsers")
          .where("nic", "==", formData.nic)
          .get()
          .then((queryGet) => {
            if (queryGet.size === 0) {
              localStorage.removeItem("timecuno");
              myfuctions
                .createUser(formData)
                .then(() => {
                  console.log("Registro");
                  toast.success("Bienvenido.");
                })
                .catch((reason) => {
                  toast.error(reason);
                });
            } else {
              myfuctions
                .loginUser(formData)
                .then(() => {
                  console.log("Acceso");
                  toast.success("Bienvenido.");
                })
                .catch((reason) => {
                  toast.error(reason);
                });
            }
          });
      } catch (error) {
        toast.error(error);
        console.log(error);
        setError(true);
      }
    },
  });

  if (error) {
    return "Ha ocurrido un error";
  }

  return (
    <div className="loginContainer">
      <form noValidate autoComplete="off" onSubmit={formik.handleSubmit}>
        <RedditTextField
          label="Nombre completo:"
          variant="filled"
          style={{ marginTop: "50px" }}
          value={formik.values.fullName}
          onChange={formik.handleChange}
          fullWidth
          error={
            formik.errors.fullName === undefined ||
            formik.touched.fullName === undefined
              ? false
              : true
          }
          helperText={
            formik.errors.fullName && formik.touched.fullName
              ? formik.errors.fullName
              : null
          }
          name="fullName"
        />

        <RedditTextField
          label="Cédula:"
          variant="filled"
          style={{ marginTop: "24px" }}
          value={formik.values.dni}
          onChange={formik.handleChange}
          fullWidth
          error={
            formik.errors.dni === undefined || formik.touched.dni === undefined
              ? false
              : true
          }
          helperText={
            formik.errors.dni && formik.touched.dni ? formik.errors.dni : null
          }
          name="dni"
          type="number"
        />
        <RedditTextField
          label="Celular:"
          variant="filled"
          style={{ marginTop: "24px" }}
          value={formik.values.mobilePhone}
          onChange={formik.handleChange}
          fullWidth
          error={
            formik.errors.mobilePhone === undefined ||
            formik.touched.mobilePhone === undefined
              ? false
              : true
          }
          helperText={
            formik.errors.mobilePhone && formik.touched.mobilePhone
              ? formik.errors.mobilePhone
              : null
          }
          name="mobilePhone"
          type="number"
        />
        <RedditTextField
          label="NIC:"
          variant="filled"
          style={{ marginTop: "24px" }}
          value={formik.values.nic}
          onChange={formik.handleChange}
          fullWidth
          error={
            formik.errors.nic === undefined || formik.touched.nic === undefined
              ? false
              : true
          }
          helperText={
            formik.errors.nic && formik.touched.nic ? formik.errors.nic : null
          }
          name="nic"
          type="number"
        />
        <div style={{ textAlign: "center", marginTop: "30px" }}>
          <SendButtonSmall
            variant="contained"
            type="submit"
            disabled={disabled}
          >
            INGRESAR
          </SendButtonSmall>
        </div>
      </form>
    </div>
  );
}

export default Login;
